import type { ReactNode } from 'react';
import { Stack } from '@mui/material';

/** Nested children container — 16px indent, 2px pitch between rows. */
export function LayersChildren({ children }: { children?: ReactNode }) {
  return <Stack sx={{ pl: 'var(--size-16)', pt: 'var(--size-2, 2px)', gap: 'var(--size-2, 2px)' }}>{children}</Stack>;
}
